// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideRoute as RawLucideRoute } from "lucide-react";
export const LucideRoute = /* @__PURE__ */ createIcon(RawLucideRoute, "LucideRoute", 2);
